import styled from 'styled-components';
import { Caption } from '@estee/elc-typography';
import { ContentSpacing } from '@estee/elc-base-theme';

const { space8, space12, space16, space24 } = ContentSpacing;

const StyledTooltipButton = styled.button`
    display: inline-flex;
    margin: auto;
    align-self: center;
    padding: 0;
    background-color: transparent;
    border: none;
    cursor: pointer;
    position: relative;
`;

const StyledTooltipHiddenText = styled(Caption)`
    text-align: left;
    padding: ${space12};

    [dir='rtl'] & {
        text-align: right;
    }
`;

const StyledTooltipTextWrapper = styled.div`
    position: absolute;
    max-width: 250px;
    width: max-content;
    z-index: 1;

    &::before {
        content: '';
        position: absolute;
        width: ${space16};
        height: ${space16};
        transform: rotate(45deg);
        z-index: -1;
    }

    &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: ${space16};
        z-index: -1;
        left: 0;
        right: 0;
        background-color: transparent;
    }

    &.placement-top,
    &.placement-top-left,
    &.placement-top-right {
        &::before {
            bottom: -${space8};
        }
        &::after {
            bottom: -${space16};
        }
    }

    &.placement-top {
        left: 50%;
        transform: translateX(-50%);

        &::before {
            left: calc(50% - ${space8});
        }
    }

    &.placement-top-left,
    [dir='rtl'] &.placement-top-right {
        left: calc(50% + ${space24});
        transform: translateX(-100%);
        right: auto;

        &::before {
            right: ${space16};
            left: auto;
        }
    }

    &.placement-top-right,
    [dir='rtl'] &.placement-top-left {
        right: calc(50% + ${space24});
        left: auto;
        transform: translateX(100%);

        &::before {
            left: ${space16};
            right: auto;
        }
    }

    &.placement-bottom,
    &.placement-bottom-left,
    &.placement-bottom-right {
        &::before {
            top: -7px;
        }
        &::after {
            top: -${space16};
        }
    }

    &.placement-bottom {
        left: 50%;
        transform: translateX(-50%);

        &::before {
            left: calc(50% - 8px);
        }
    }

    &.placement-bottom-left,
    [dir='rtl'] &.placement-bottom-right {
        left: calc(50% + ${space24});
        right: auto;
        transform: translate(-100%);

        &::before {
            right: ${space16};
            left: auto;
        }
    }

    &.placement-bottom-right,
    [dir='rtl'] &.placement-bottom-left {
        right: calc(50% + ${space24});
        left: auto;
        transform: translate(100%);

        &::before {
            left: ${space16};
            right: auto;
        }
    }
`;

export { StyledTooltipButton, StyledTooltipHiddenText, StyledTooltipTextWrapper };
